import React from 'react';
import GuideLayout from '../GuideLayout';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const receiveChart = `graph LR
    A["供应商送货到达"] --> B["打开收货单\\n扫码收货"]
    B --> C["扫码品检"]
    C --> D{"合格?"}
    D -->|"合格"| E["确认入库\\n上架"]
    D -->|"不合格"| F["标记不良\\n退货"]`;
const pickChart = `graph LR
    A["收到拣料任务"] --> B{"拣料去向"}
    B -->|"生产领料"| C["扫码绑定拣料篮"]
    C --> D["按系统指引\n扫码拣料"]
    D --> E["扫码确认\n发料至车间"]
    B -->|"销售发货"| F["扫码拣料"]
    F --> G["扫码打包\n出库发货"]`;
const sections = [{
  id: 'receive',
  label: '收货流程'
}, {
  id: 'pick',
  label: '发货/拣料流程'
}, {
  id: 'others',
  label: '其他操作'
}];
export default function Warehouse() {
  return /*#__PURE__*/React.createElement(GuideLayout, {
    title: "\u4ED3\u5E93\u2014\u2014\u626B\u7801\u5373\u7528",
    firstQuestion: "\u8D27\u5230\u4E86/\u8981\u53D1\u8D27\uFF0C\u6211\u8BE5\u600E\u4E48\u64CD\u4F5C\uFF1F",
    sections: sections
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "receive"
  }, /*#__PURE__*/React.createElement("h2", null, "\u6536\u8D27\u6D41\u7A0B"), /*#__PURE__*/React.createElement("blockquote", null, "\u4ED3\u5E93\u73AF\u8282\u8BBE\u8BA1\u5F97\u975E\u5E38\u7B80\u5355\uFF1A", /*#__PURE__*/React.createElement("strong", null, "\u62FF\u8D77\u624B\u673A\uFF0C\u626B\u7801\u5C31\u80FD\u5E72\u6D3B"), "\u3002\u4E0D\u9700\u8981\u8BB0\u590D\u6742\u6D41\u7A0B\u3002"), /*#__PURE__*/React.createElement("h3", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "\u6BCF\u6B65\u90FD\u626B\u7801\uFF0C\u6BD4\u624B\u5DE5\u5F55\u5165\u53C8\u5FEB\u53C8\u51C6"), /*#__PURE__*/React.createElement("li", null, "\u54C1\u68C0\u65F6\u5BF9\u7167\u4E0D\u826F\u6807\u7B7E\u5224\u5B9A\u5408\u683C\u6570\u91CF"), /*#__PURE__*/React.createElement("li", null, "\u54C1\u68C0\u5B8C\u6210\u540E\u7CFB\u7EDF\u81EA\u52A8\u89E6\u53D1\u5165\u5E93")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: receiveChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "pick"
  }, /*#__PURE__*/React.createElement("h2", null, "\u53D1\u8D27/\u62E3\u6599\u6D41\u7A0B"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: pickChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "others"
  }, /*#__PURE__*/React.createElement("h2", null, "\u5176\u4ED6\u64CD\u4F5C"), /*#__PURE__*/React.createElement("h3", null, "\u76D8\u70B9"), /*#__PURE__*/React.createElement("p", null, "\u9009\u5206\u533A \u2192 \u626B\u7801\u76D8\u70B9\uFF08\u53EF\u76F2\u76D8\uFF09\u2192 \u7CFB\u7EDF\u81EA\u52A8\u5BF9\u6BD4\u5DEE\u5F02 \u2192 \u786E\u8BA4\u8C03\u6574"), /*#__PURE__*/React.createElement("h3", null, "\u5E93\u5B58\u67E5\u8BE2"), /*#__PURE__*/React.createElement("p", null, "\u652F\u6301\u5E93\u5B58\u6D41\u6C34\u3001\u5E93\u5B58\u5FEB\u7167\uFF08\u7CBE\u786E\u5230\u67D0\u5929\uFF09\u3001\u591A\u4ED3\u5E93\u591A\u5E93\u4F4D"), /*#__PURE__*/React.createElement("h3", null, "\u9501\u5B9A/\u91CA\u653E"), /*#__PURE__*/React.createElement("p", null, "\u5230\u8D27\u672A\u5206\u914D\u7684\u8D27\u53EF\u9501\u5B9A\u9632\u8BEF\u7528")));
}